export default __webpack_public_path__ + "static/media/account_circle.407a8aef.svg";